import { REVIEW_AVERAGE, REVIEW_COUNT } from "@/consts/reviews";
import type { Product } from "@/graphql/storefront/generated";
import { SHOP_FAQS, shopFaqParagraphText } from "@/views/shop/shopContent";

const PRODUCT_URL = "https://maticrobots.com/product";

const toPlainText = (value: string): string =>
  value
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const buildProductStructuredData = (
  product: Product,
): Record<string, unknown> => {
  const firstVariant = product.variants.edges[0]?.node;
  const image = product.images.edges.map(({ node }) => String(node.url));

  return {
    "@context": "https://schema.org",
    "@type": "Product",
    name: product.title,
    description: toPlainText(product.description),
    ...(image.length > 0 ? { image } : {}),
    ...(firstVariant?.sku ? { sku: firstVariant.sku } : {}),
    ...(firstVariant
      ? {
          offers: {
            "@type": "Offer",
            price: firstVariant.price.amount,
            priceCurrency: firstVariant.price.currencyCode,
            availability: firstVariant.availableForSale
              ? "https://schema.org/InStock"
              : "https://schema.org/OutOfStock",
            url: PRODUCT_URL,
            seller: {
              "@type": "Organization",
              name: "Matic Robots",
            },
          },
        }
      : {}),
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: REVIEW_AVERAGE,
      reviewCount: REVIEW_COUNT,
    },
  };
};

export const buildShopFaqStructuredData = (): Record<string, unknown> => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: SHOP_FAQS.groups.flatMap((group) =>
    group.items.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: [item.lead, ...item.answer.map(shopFaqParagraphText)].join(" "),
      },
    })),
  ),
});
